import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useHistoryNav } from "@/features/navigation/useHistoryNav";

interface Props {
  onClick?: () => void;
  disabled?: boolean;
  isNext?: boolean;
  ariaLabel?: string;
  isContainerVisible?: boolean;
}

const CustomBackButton: React.FC<Props> = ({
  onClick,
  disabled = false,
  isNext = false,
  ariaLabel = "",
  isContainerVisible = true
}) => {
  // Without a handler, mirror the browser's history; with nothing to go back
  // to, step up to the home page.
  const { goBack, goForward } = useHistoryNav({ fallbackBackTo: "/" });

  const handleNavigate = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (isNext) goForward();
    else goBack();
  };

  if (isContainerVisible) {
    return (
      <Button
        variant="ghost"
        size="md"
        aria-label={ariaLabel}
        disabled={disabled}
        className="justify-start"
        onClick={handleNavigate}
      >
        {isNext ? <ArrowRight /> : <ArrowLeft />}
        {ariaLabel}
      </Button>
    );
  }
  return (
    <span className="inline-flex text-fg-3 [&_svg]:size-3.5">
      {isNext ? <ArrowRight /> : <ArrowLeft />}
    </span>
  );
};

export default CustomBackButton;
